export default __webpack_public_path__ + "static/media/Oo.b7204d3f.wav";